import { PopoverContent } from '@radix-ui/react-popover';
import { rem } from 'polished';
import styled from 'styled-components';

import {
  borderRadius,
  fontSizes,
  fontWeights,
  spacing,
  zIndexes,
} from '../../theme';
import colors from '../../theme/constants/colors';
import { hexWithOpacity } from '../../utils';

export const DatePickerContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: fit-content;
`;

export const DatePickerPopoverContentRoot = styled(PopoverContent)`
  z-index: ${zIndexes.modal};
  box-sizing: border-box;
  max-height: ${rem(380)};
  width: ${rem(320)};
  overflow: hidden;
  border-radius: ${borderRadius['3x']};
  border: 1px solid #c2c4ce;
`;

export const CalendarContainer = styled.div.attrs({ role: 'menu' })`
  z-index: ${zIndexes.modal};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${spacing['4x']};
  width: 100%;

  background-color: #f4f4f6;
  padding: ${spacing['6x']};
  padding-bottom: ${spacing['8x']};

  .rdp {
    margin: 0;

    --rdp-cell-size: 32px;
  }

  .rdp-table,
  .rdp-month {
    width: 100%;

    /** reset for max-width (it would set some unwanted max-width based on --rdp-cell-size otherwise) */
    max-width: 100%;
  }

  .rdp-caption {
    display: none;
  }

  .rdp-head_cell {
    color: #1e8560;
    font-weight: ${fontWeights.medium};
    line-height: 16px;

    /** note: this is temporary workaround until we implement proper weekday formatter */
    font-size: 0;

    &::first-letter {
      font-size: ${fontSizes.m};
    }
  }

  .rdp-day {
    /** margin is workaround to make elements inside table cell centered */
    margin-left: ${rem(6)};

    color: #32395a;
    font-weight: ${fontWeights.regular};
    font-size: ${fontSizes.m};
    line-height: 16px;

    &_disabled {
      background-color: transparent !important;
      cursor: default;
      pointer-events: none;
    }

    &_selected {
      color: ${colors.white};
      background-color: ${colors.dollar};

      &:focus-visible {
        outline: none;
      }
    }

    &:focus-visible {
      color: ${colors.white};
      background-color: ${hexWithOpacity(colors.dollar, 0.4)};
      border: 2px solid ${hexWithOpacity(colors.dollar, 0.7)};
    }

    &:focus {
      outline: none;
    }

    &:not(.rdp-day_disabled, .rdp-day_selected, .rdp-day_outside):hover {
      color: ${colors.white};
      background-color: ${colors.dollar} !important;
    }
  }
`;

export const Caption = styled.div`
  display: flex;
  gap: ${spacing['4x']};
  justify-content: center;
`;
